export function disableButtonSave(
  idDivElementSave,
  idDivElementCancel,
  channelColorSaved,
  setChannelColorSaved,
  setButtonChannel,
  document
) {
  if (channelColorSaved === true) {
    setButtonChannel(false);
    setChannelColorSaved(false);
    disableOrEnableButtonsSave(
      idDivElementSave,
      idDivElementCancel,
      true,
      document
    );
  }
}
export function disableOrEnableButtonsSave(
  idDivElementSave,
  idDivElementCancel,
  disableButton,
  document
) {
  document.getElementById(idDivElementSave).disabled = disableButton;
  document.getElementById(idDivElementCancel).disabled = disableButton;
} 
export function clickSaveChannel(
  setButtonChannel,
  setChannelButtonEdit,
  doChangeChannel
) {
  setButtonChannel(false);
  setChannelButtonEdit(false);
  disableOrEnableButtonsSave(
    "buttonChannel",
    "buttonChannelCancel",
    true,
    document
  );
  doChangeChannel();
}

export function clickCancelChannel(
  setButtonChannel,
  setChannelButtonEdit,
  doCancelChangeChannel
) {
  setButtonChannel(false);
  setChannelButtonEdit(false);
  disableOrEnableButtonsSave(
    "buttonChannel",
    "buttonChannelCancel",
    true,
    document
  );
  doCancelChangeChannel();
}

export function clickSaveChannelColor(
  setButtonChannel,
  setChannelButtonEdit,
  doChangeColorChannel
) {
  setButtonChannel(false);
  setChannelButtonEdit(false);
  disableOrEnableButtonsSave(
    "buttonChannelColor",
    "buttonChannelCancelColor",
    true,
    document
  );
  doChangeColorChannel();
}
export function clickCancelChannelColor(
  setChannelButtonEdit,
  setButtonChannel,
  doCancelChangeChannel
) {
  setChannelButtonEdit(false);
  setButtonChannel(false);
  disableOrEnableButtonsSave(
    "buttonChannelColor",
    "buttonChannelCancelColor",
    true,
    document
  );
  doCancelChangeChannel();
}
